import React, {useState, useEffect} from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styled from "styled-components";
import Text from "../../styles/Text";
import {Content} from "../../styles/GlobalStyles";
import {Link} from "react-router-dom";

const responsive = {
   superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: {max: 4000, min: 3000},
      items: 1,
   },
   desktop: {
      breakpoint: {max: 3000, min: 1024},
      items: 1,
   },
   tablet: {
      breakpoint: {max: 1024, min: 464},
      items: 1,
   },
   mobile: {
      breakpoint: {max: 464, min: 0},
      items: 1,
   },
};

export default function CarouselComplete({slides}) {
   const [isMobile, setMobile] = useState(true);
   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);

   if (isMobile) {
      if (slides.data) {
         let slideItem = slides.data[0];
         let urlList = slideItem.url.split("/");
         let cleanUrl = urlList[urlList.length - 1];
         return (
            <Slide
               style={{
                  backgroundImage: `url(http://domecqapi.trebolbit.com/${
                     isMobile ? slideItem.pathImageWebMobile : slideItem.pathImageWebDesktop
                  })`,
               }}
            >
               <Content>
                  <div className="legend">
                     <Text className="title">{slideItem.title}</Text>
                     <LinkCarousel to={`/${cleanUrl}`}>
                        <Text className="text">{slideItem.subtitle}</Text>
                        <img src={require("../../assets/icons/to_right.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                     </LinkCarousel>
                  </div>
               </Content>
            </Slide>
         );
      }
      return null;
   }

   return (
      <Carousel
         responsive={responsive}
         containerClass="carousel-container"
         /* customRightArrow={<CustomRightArrow />}
         customLeftArrow={<CustomLeftArrow />} */
         infinite={true}
      >
         {React.Children.toArray(
            slides.data.map((slideItem) => {
               let urlList = slideItem.url.split("/");
               let cleanUrl = urlList[urlList.length - 1];
               return (
                  <Slide
                     style={{
                        backgroundImage: `url(http://domecqapi.trebolbit.com/${
                           isMobile ? slideItem.pathImageWebMobile : slideItem.pathImageWebDesktop
                        })`,
                     }}
                  >
                     <Content>
                        <div className="legend">
                           <Text className="title">{slideItem.title}</Text>
                           <LinkCarousel to={`/${cleanUrl}`}>
                              <Text className="text">{slideItem.subtitle}</Text>
                              <img
                                 src={require("../../assets/icons/to_right.png")}
                                 alt="arrow"
                                 width="25px"
                                 height="25px"
                                 className="imgTo"
                              />
                           </LinkCarousel>
                        </div>
                     </Content>
                  </Slide>
               );
            }),
         )}

         {/*  <Slide style={{backgroundImage: `url(${returnImg("banner02")})`}}>
            <Content>
               <div className="legend">
                  <Text className="title">
                     Experimenta. <br />
                     Descubre nuevas fórmulas.
                  </Text>
                  <LinkCarousel to="/certificado_prime">
                     <Text className="text">Certificado Prime Domecq</Text>
                     <img src={require("../../assets/icons/to_right.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                  </LinkCarousel>
               </div>
            </Content>
         </Slide>
         <Slide style={{backgroundImage: `url(${returnImg("banner03")})`}}>
            <Content>
               <div className="legend">
                  <Text className="title">
                     Compartimos contigo
                     <br />
                     la misma pasión por innovar.
                  </Text>
                  <LinkCarousel to="/programa_emblem">
                     <Text className="text">Programa Emblem Domecq</Text>
                     <img src={require("../../assets/icons/to_right.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                  </LinkCarousel>
               </div>
            </Content>
         </Slide>
         <Slide style={{backgroundImage: `url(${returnImg("banner04")})`}}>
            <Content>
               <div className="legend">
                  <Text className="title">
                     Acércate.
                     <br />
                     Conoce todas nuestras marcas.
                  </Text>
                  <LinkCarousel to="/programa_enterprise">
                     <Text className="text">Programa Enterprise Domecq</Text>
                     <img src={require("../../assets/icons/to_right.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                  </LinkCarousel>
               </div>
            </Content>
         </Slide>
         <Slide style={{backgroundImage: `url(${returnImg("banner05")})`}}> 
            <Content>
               <div className="legend">
                  <Text className="title">
                     El lugar de la experiencia,
                     <br />
                     pasión y conocimiento.
                  </Text>
                  <LinkCarousel to="/domecq_academy">
                     <Text className="text">Conoce Domecq Academy</Text>
                     <img src={require("../../assets/icons/to_right.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                  </LinkCarousel>
               </div>
            </Content>
         </Slide>*/}
      </Carousel>
   );
}

const Slide = styled.div`
   width: 100%;
   height: 92vh;
   background-size: cover;
   background-repeat: no-repeat;

   & .legend {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: justify !important;
      pointer-events: none;
      user-select: none;

      & a {
         pointer-events: all;
      }
   }

   & .title {
      font-size: 2.7em;
      color: white;
   }

   & .ImageBox {
      width: 700px;
      height: auto;
   }

   @media screen and (max-width: 1600px) {
      & .title {
         font-size: 2em;
      }
   }

   @media screen and (max-width: 1400px) {
      & .title {
         font-size: 1.8em;
      }
   }

   @media screen and (max-width: 800px) {
      height: 70vh;

      & .title {
         font-size: 1.5em;
      }
   }

   @media screen and (max-width: 500px) {
      height: 71vh;
      & .legend {
         & .title {
            font-size: 1.2em;
            width: 60%;
            line-height: 1.3em;
            text-align: initial;
         }
      }
   }
`;

const LinkCarousel = styled(Link)`
   display: flex;
   align-items: center;
   border: none;
   text-decoration: none;
   cursor: pointer;
   width: 30%;

   margin-top: 2.5em;

   & .text {
      font-weight: 300;
      font-size: 1.5em;
      color: white;
      font-weight: 400;
      text-transform: capitalize;
      line-height: 1em;
   }

   & img.imgTo {
      filter: brightness(2.5);
      margin-left: 1.5em;
      width: 25px;
      height: 25px;
      margin-top: 6px;
   }

   @media screen and (max-width: 1600px) {
      & .text {
         font-size: 1em;
      }
   }

   @media screen and (max-width: 800px) {
      & .text {
         font-size: 0.8em;
      }

      & img.imgTo {
         margin-left: 1em;
         width: 15px;
         height: 15px;
         margin-top: 6px;
      }
   }

   @media screen and (max-width: 500px) {
      width: 100%;
      & .text {
         font-size: 0.9em;
      }
      & img.imgTo {
         width: 1em;
         height: 1em;
      }
   }
`;
